"use client";

import React, { useState } from "react";
import styles from "./ChallengeCard.module.scss";
import FormattedDate from "../FormattedDate";
import Link from "next/link";
import clsx from "clsx";
import ShareMenu from "./ShareMenu";
import DeleteConfirm from "./DeleteConfirm";
import If from "@/components/common/If";

/**
 *
 * ChallengeCard
 *
 */
const ChallengeCard = ({
  challenge = {} as any,
  onDelete = (id?: string) => {},
  isLight = true,
  isThinknado = false,
  isIdea = false,
  ...props
}) => {
  const [state, setState] = useState("idle");
  const sessionHref = challenge?.id ? `/app/session/${challenge.id}` : "/app/session";

  return (
    <>
      <article
        className={clsx(
          styles["challenge-card"],
          "text-black p-4 challenge-card relative",
          "flex flex-col justify-between gap-2  max-w-full aspect-auto md:aspect-square min-h-[300px]",
          state === "deleting" && "opacity-25",
          // isThinknado && "text-white",
          // isIdea ? "bg-pink" : "bg-purple"
          'border border-black/20 bg-white'
        )}
        {...props}
      >
        <Link
          href={sessionHref}
          className="absolute inset-0 z-0"
          aria-label={`View ${isThinknado ? 'thinknado' : 'challenge'}: ${challenge.challenge || challenge.typedChallenge || challenge.idea}`}
        >
          <span className="sr-only">View {isThinknado ? 'thinknado' : 'challenge'} details</span>
        </Link>
        
        <div className="relative z-10 min-h-[75%] flex flex-col pointer-events-none"
        >
          <If condition={!isThinknado}>
            <div className="aspect-video w-full overflow-hidden">
              {challenge.whatIfImage ? (
                <img
                  src={`/cards/WHATIF_B_American-poker-size-${challenge.whatIfImage}.jpg`}
                  className="w-[100%] aspect-auto md:aspect-square object-cover transform rotate-90 h-[200%] top-[-25%] relative"
                  alt="Challenge card image"
                />
              ) : (
                <div className="w-[100%] aspect-square bg-image-placeholder relative" />
              )}
            </div>
          </If>
          <div className="detail px-0 flex flex-col gap-4 pb-3 justify-start items-start text-current">
            <h2
              className={`text-xl font-semibold truncate ${
                !isLight ? "text-white" : "text-black"
              }`}
            >
              {challenge.challenge ||
                challenge.typedChallenge ||
                challenge.idea}
            </h2>
          </div>
        </div>

        <div className="stack gap-2 relative z-10">
          <If condition={isThinknado}>
            <div className="flex items-center gap-8">
              <span className="text-sm text-current flex items-center gap-1  font-light">
                Ideas {challenge._count.ideas}
              </span>
              <span className="text-sm text-current flex items-center gap-1  font-light">
                Bets {challenge._count.bets}
              </span>
            </div>
          </If>
          <div className="px-0 pb-4 flex justify-between items-center">
            <FormattedDate
              className={`opacity-50 ${!isLight ? "text-white" : "text-black"}`}
              date={challenge.createdAt}
            />
            <div className="flex items-center gap-2 pointer-events-auto">
              <DeleteConfirm
                id={challenge.id}
                onDelete={(state) => {
                  setState(state);
                  onDelete(challenge.id);
                }}
              />
              <ShareMenu
                id={challenge.id}
                initialIsPublic={challenge.isPublic}
              />
            </div>
          </div>
        </div>
        {state === "deleting" && <span>Deleting...</span>}
      </article>
    </>
  );
};

export default ChallengeCard;
